<template>
	<div class="wrapInfo">
		<h3 class="titH3">
      反馈信息
			<span v-if="!downIf" class="floatR" @click="downIf = true">收起 <i class="el-icon-arrow-up"></i></span>
			<span v-if="downIf" class="floatR" @click="downIf = false">展开 <i class="el-icon-arrow-down"></i></span>
			<hr>
		</h3>
		<div :class="downIf?'h0':''" class="infoDivBox">
			<div class="row" v-if="datas.closeTime">
				<span class="titSpan">关闭时间：</span>
				{{datas.closeTime}}
			</div>
			<!-- <div class="row" v-if="datas.closeTime">
				<span class="titSpan">关闭人：</span>
				{{datas.feedbackTime}}
			</div> -->
			<div class="row" v-if="InfoType == 'info'">
				<span class="titSpan">反馈时间：</span>
				{{datas.feedbackTime}}
			</div>
			<div class="row">
				<span class="titSpan"><i v-if="InfoType != 'info'">*</i>反馈部门：</span>
        <span v-if="InfoType == 'info'">{{datas.feedbackCompay}}</span>
        <el-input class="w300" v-model="datas.feedbackCompay" placeholder="请输入反馈部门" v-if="InfoType != 'info'"></el-input>
			</div>
			<div class="row">
				<span class="titSpan"><i v-if="InfoType != 'info'">*</i>反馈人：</span>
        <span v-if="InfoType == 'info'">{{datas.feedbackPerson}}</span>
        <el-input class="w300" v-model="datas.feedbackPerson" placeholder="请输入反馈人" v-if="InfoType != 'info'"></el-input>
			</div>
			<div class="row">
				<span class="titSpan" style="vertical-align: top;"><i v-if="InfoType != 'info'">*</i>反馈内容：</span>
        <span style="width: 300px;display: inline-block;" v-if="InfoType == 'info'">{{datas.feedbackContent}}</span>
				<el-input class="w300" type="textarea" :rows="4" v-model="datas.feedbackContent" maxlength="500" 
									placeholder="请输入反馈内容，500字以内" v-if="InfoType != 'info'"></el-input>
			</div>
		</div>
	</div>
</template>

<script>
	import { postFeedback, getSchoolInfoFind} from 'api/com'
	export default {
    props: {
      InfoType: {
        default: ''
      },
			feedback: {
				default: ''
			},
			recordId: {
				default: ''
			}
    },
		data() {
			return {
				downIf: false,
				datas: {
					feedbackCompay:'',
					feedbackContent: '',
					feedbackPerson: '',
					id: ''
				}
			}
		},
		mounted() {
			this.datas.id = this.recordId;
			if(this.InfoType != 'add'){
				getSchoolInfoFind(this.recordId).then(r => {
					if(r.code == 200){
						this.datas.feedbackCompay = r.data.feedbackCompay;
						this.datas.feedbackContent = r.data.feedbackContent;
						this.datas.feedbackPerson = r.data.feedbackPerson; 
						this.datas.feedbackTime = r.data.feedbackTime; 
					}
				})
			}
		},
		watch: {
			feedback: function() {
				if(this.datas.feedbackCompay == ''){
					this.$message.warning('请输入反馈部门名称');
					return
				}else if (this.datas.feedbackPerson == '') {
					this.$message.warning('请输入反馈人');
					return
				}else if (this.datas.feedbackContent == '') {
					this.$message.warning('请输入反馈内容');
					return
				}
				postFeedback(this.datas).then(r => {
					if(r.code == 200){
						this.$message.success('反馈成功');
						this.$emit('goBack')
					}
				})
			}
		},
	}
</script>

<style scoped lang="scss">
	.wrapInfo {
		background: #fff;
		overflow: hidden;
    border-radius:4px;
		.titH3{
			font-size: 16px;
			font-weight: 100;
			height: 25px;
			margin: 16px 0;
			padding: 0 30px 0 24px;
			border-left: 6px solid #70CE97;
			span{
				font-size: 14px;
			}
			hr{
				border-width: 0.5px;
				margin-top: 20px;
			}
		}
		.infoDivBox{
			width: 450px;
			margin: 0 auto 20px;
			padding: 10px 0;
			.row{
				font-size: 14px;
				color: #666666;
				margin-top: 20px;
				.titSpan{
					display: inline-block;
					width: 100px;
					text-align: right;
					i{
						color:#F02423;
						margin-right: 5px;
					}
				}
			}
		}
		.h0{
			height: 0;
			margin-bottom: 0;
			padding: 0;
		}
  }
</style>